"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Party {
}
exports.default = Party;
;
//# sourceMappingURL=Party.js.map